import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { facebookAccountSetup } from "@/services/api/cresivoxServer";
import { iFacebookAccountDTO, REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// Add Payment Gateway
export const addFacebookAccountDetails = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { data: iFacebookAccountDTO },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addFacebookAccountDetails"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await facebookAccountSetup.createFacebookAccount(data);
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  paymentGateway: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({ httpStatusCode, message });
            }
          }
          default: {
            return rejectWithValue({ httpStatusCode, message });
          }
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

// Get Facebook Account Deatils List
export const getFacebookAccountList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getFacebookAccountList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (_, { rejectWithValue }) => {
    try {
      const response = await facebookAccountSetup.getAllFacebookAccount();
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                    data: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({ httpStatusCode, message });
            }
          }
          default: {
            return rejectWithValue({ httpStatusCode, message });
          }
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

